import { combineReducers } from 'redux';
import { config } from './Reducers/index';
import { Filter } from './Reducers/ProjectDetails';

export default combineReducers({
    config, Filter
})